/*eslint no-unused-vars: "error"*/
/* exported toggle_view_karte_kachel */

import 'cookieconsent';
window.cookieconsent.initialise({
    "palette": {
        "popup": {
            "background": "#529735"
        },
        "button": {
            "background": "#154a93"
        }
    },
    "content": {
        "message": "Diese Website nutzt Cookies, um Ihnen eine bestmögliche Funktionalität bieten zu können. Details finden Sie in der",
        "dismiss": "Verstanden",
        "link": "Datenschutzerklärung",
        "href": "https://paludikultur-niedersachsen.de/datenschutz.html"
    }
});

import '../../node_modules/shariff/dist/shariff.min.js';

import './module/modul_form.js';
import './module/modul_accordion2.js';


// import '../../build/js/static/paludi_main-min.js'


import 'magnific-popup';
import './module/magnificPopup_universal.js';




import 'mmenu-light'
document.addEventListener("DOMContentLoaded", function () {
    var menu = new MmenuLight(document.querySelector("#nav_kachel"), "(max-width: 899px)");

    /* eslint-disable no-unused-vars */
    var navigator = menu.navigation({
        /* eslint-enable no-unused-vars */
        // options
        title: "Menu",
        slidingSubmenus: true,
        selected: "self",
        theme: "light"
    });
    var drawer = menu.offcanvas({
        position: "left"
    });

    document.querySelector("button#mmenu_button").addEventListener("click", function (evnt) {
        evnt.preventDefault();
        drawer.open();
    });
});

import './module/modul_tab.js';
// Seitenleisten-Tab im Outtake, weil beim Kompelieren sl_tab() gelöscht wird




import mixitup from 'mixitup';

var gallery_odb = document.getElementById("kachel_all_wrapper");
if (gallery_odb) {
    var mixer = mixitup('.mixitup_wrapper', {
        selectors: {
            target: '.map_db_item'
        },
        classNames: {
            block: ''
        },
        animation: {
            queueLimit: 5,
            // duration: 300
            // effectsOut: 'fade translateY(-100%)'
            enable: false
        }
    });

    mixer.filter('all');
}

